import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

import { Page } from 'modules/layout/components/Page';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';

const StatusPage = loadable(
  async () => {
    const module = await import('./StatusPage');

    return module.StatusPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

export const StatusPageContainer = () => {
  return (
    <Page>
      <NoSSRGuard>
        <StatusPage />
      </NoSSRGuard>
    </Page>
  );
};
